import React from "react";
import { motion } from "framer-motion";

export default function Admission() {
  return (
    <div className="overflow-hidden">
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row align-items-center">
            <motion.div 
              className="col-lg-7 mb-5 mb-lg-0"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <p className="section-title pr-5">
                <span className="pr-2">Admission</span>
              </p>
              <h1 className="mb-4">Admission form</h1>
              <b>
                Admission for the academic year 2024-25 from KG to Cambridge AS-A Level is open now. Please
                fill the admission form or contact directly with us to start your journey with our school.
              </b>
              <ul className="list-inline mt-3">
                <motion.li 
                  className="py-2"
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.4 }}
                >
                  <i className="fa fa-check text-success mr-3" />
                  Academic Year 2024-25
                </motion.li>
                <motion.li 
                  className="py-2"
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.5 }}
                >
                  <i className="fa fa-check text-success mr-3" />
                  From KG to Cambridge AS-A Level
                </motion.li>
              </ul>
              <a href="/" className="btn btn-primary mt-4 py-2 px-4">
                Download
              </a>
            </motion.div>
            <motion.div 
              className="col-lg-5"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <img src={require('../assets/admission.jpg')} style={{
                width: "100%", 
                borderRadius: 12,
                boxShadow: "0 1rem 3rem rgba(0,0,0,.1)"
              }} alt="" />
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
}
